// removed by extract-text-webpack-plugin
module.exports = {"nav":"xPMuEcSexOLef49a8U7-a","container":"cEvcg2ANVDrsn2HFL3ZyQ","logo":"_1HMkq7yYuZw1NDkSN9wy66","links":"_3RsfDdYPzm89a5XFGxkMmm"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Home/Layout/Nav/styles.css
// module id = 1644
// module chunks = 85